
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/styled-system/[...slug]",
      function () {
        return require("private-next-pages/docs/styled-system/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/styled-system/[...slug]"])
      });
    }
  